import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import store from '@/store/index.js';
import axios from '@/plugins/axios.js';
import VueAxios from 'vue-axios';
import mitt from 'mitt';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/css/design.css';

const emitter = mitt();
window.Fire = emitter;

const app = createApp(App);

app.use(router);
app.use(store);
app.use(VueAxios, axios);
app.use(Toast, {
  timeout: 3000,
  position: 'bottom-left',
  closeOnClick: true,
});

// Avatar URL helper — handles both local filenames and absolute OAuth URLs (Google, etc.)
const _imgBase = (process.env.VUE_APP_IMAGE_URL || '').replace(/\/$/, '');
app.config.globalProperties.$avatarSrc = function(avatar, folder = 'users') {
  if (!avatar) return '/assets/avatar.png';
  if (/^https?:\/\//i.test(avatar)) return avatar;
  return folder ? `${_imgBase}/${folder}/${avatar}` : `${_imgBase}/${avatar}`;
};

// Compatibility shim for existing this.$toastr.s / this.$toastr.e calls
app.config.globalProperties.$toastr = {
  s: (msg) => app.config.globalProperties.$toast?.success(msg),
  e: (msg) => app.config.globalProperties.$toast?.error(msg),
  w: (msg) => app.config.globalProperties.$toast?.warning(msg),
  i: (msg) => app.config.globalProperties.$toast?.info(msg),
};

// Lazy-load Pagination component
app.component('pagination', () => import('./components/Pagination.vue'));

app.mount('#app');
